import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/useLanguage";
import { localizePublicPath, isLocalizedPublicPath } from "@/lib/publicRoutes";

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const switchLanguage = (nextLanguage: 'fr' | 'en') => {
    setLanguage(nextLanguage);

    if (isLocalizedPublicPath(location.pathname)) {
      const nextPath = localizePublicPath(`${location.pathname}${location.search}${location.hash}`, nextLanguage);
      navigate(nextPath);
    }
  };

  return (
    <div className="flex items-center gap-1 rounded-full bg-muted/50 p-1">
      <Button
        variant="ghost"
        size="sm"
        className={`h-7 rounded-full px-3 text-xs font-medium transition-all ${
          language === 'en'
            ? 'bg-background text-foreground shadow-sm hover:bg-accent hover:text-white'
            : 'text-muted-foreground hover:bg-accent hover:text-white'
        }`}
        onClick={() => switchLanguage('en')}
      >
        EN
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className={`h-7 rounded-full px-3 text-xs font-medium transition-all ${
          language === 'fr'
            ? 'bg-background text-foreground shadow-sm hover:bg-accent hover:text-white'
            : 'text-muted-foreground hover:bg-accent hover:text-white'
        }`}
        onClick={() => switchLanguage('fr')}
      >
        FR
      </Button>
    </div>
  );
}
